import { FETCH_GTV_REQUEST, FETCH_GTV_DATA, FETCH_GTV_ERROR, RESET_GTV_DATA } from './gtvTypes';

const initialState = {
  loading: false,
  error: '',
  overall: [],
  creative: []
};

const gtvReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GTV_REQUEST:
      return { ...state, loading: true, error: '' };
    case FETCH_GTV_DATA:
      return {
        ...state,
        loading: false,
        error: '',
        overall: action.payload.overall,
        creative: action.payload.creative
      };
    case FETCH_GTV_ERROR:
      return { ...initialState, error: action.payload };
    case RESET_GTV_DATA:
      return { ...initialState };
    default:
      return state;
  }
};

export default gtvReducer;
